// URL encoding constants
export const COLLECTIONS_JOIN_SYMBOL_URL = ",";

// Collection limits
export const COLLECTION_NAME_MIN_LENGTH = 2;
export const COLLECTION_NAME_MAX_LENGTH = 64;

// Regex patterns
export const COLLECTION_NAME_PATTERN = /^[\p{L}\p{N}\s_\-().]+$/u;
